export enum Constants {
  GET_ORGANIZATIONS = 'GET_ORGANIZATIONS',
  GET_APPLICATIONS = 'GET_APPLICATIONS',
  SET_CURRENT = 'SET_CURRENT',
}

export interface IOrganizations {
  id: number
  name: string
  applications: any[]
}

export interface IOrganizationsState {
  list: IOrganizations[]
  current: any | null
}
